export interface EditableItemConfiguration {
  type: EditableItemType;
  header: string;
  content?: any; // Model for input and group of radioButtons
  selection?: any[]; // Model in case of MultiSelect
  suggestions?: any[]; // This is for AutoComplete (multiselect) and MultiSelect
  suggestionsTranslate?: boolean; // Set to true for translationKeys as suggestions, default false for values (e.g. organization-name)
  filter?: any; // This is only needed for AutoComplete
  field?: any; // The name of the field to display
  // This is for a group of radiobuttons or a group of checkboxes
  inputs?: InputConfiguration[];
  placeholderFrom?: string; // placeholder for from
  placeholderTo?: string; // placeholder for to
  disabled?: boolean; // to disable the whole editableItem
}

// This is used to configure a single checkBox or a single radioButton. Multiple radioButtons or checkBoxes can be grouped to a group with a common header in EditableItemConfiguration.inputs.
export interface InputConfiguration {
  label: string;
  value: any;
  // This indicates if the checkbox / radiobutton is selected by default and is needed for resetting
  isSelectedByDefault?: boolean;
  // This is for the model / value of checkBoxes
  selectedValue?: any;
  disabled?: boolean;
}

export enum EditableItemType {
  INPUT = 'input',
  AUTOCOMPLETE = 'autoComplete',
  MULTISELECT = 'multiselect',
  RADIOBUTTONS = 'radiobuttons',
  CHECKBOXES = 'checkboxes',
  DATE_FROM_TO = 'date-from-to'
}
